import React from "react";
import { Canvas } from "@react-three/fiber";
import { OrbitControls, PerspectiveCamera } from "@react-three/drei";
import useWindowSize from "../../hooks/useWindowSize";

import Stars from "./Stars";
import Planets from "./Planets";
// import Planet from "./Planet";

import "./Home.scss";

const Scene = (props) => {
  const { planetData } = props;
  const windowSize = useWindowSize();

  return (
    <div className="home__canvas-wrapper">
      <Canvas>
        <ambientLight intensity={1} />
        {windowSize.width >= 750 ? (
          <PerspectiveCamera makeDefault position={[0, 3, 10]} />
        ) : (
          <PerspectiveCamera makeDefault position={[0, 10, 20]} />
        )}

        <OrbitControls />
        <Stars />
        <Planets planetData={planetData} />
      </Canvas>
    </div>
  );
};

export default Scene;
